/**
 * @file Contains helper functions intended for global use.
 * @author Frankie D <fdedeo@yahoo.com>
 */

/**
 * Generates a cryptographically secure random number in [min..max] inclusive.
 * @param {number} min
 * @param {number} max
 * @returns {number}
 */
export function CSPRNG(min = 0, max = 100) {
  // Initialize an empty unsigned 32-bit array
  const byteArray = new Uint32Array(1);
  // Fill the aforementioned array with a cryptographically generated random value
  crypto.getRandomValues(byteArray);
  // Ensure the return value is in range [min..max] inclusive
  return ~~((byteArray[0] / 0x100000000) * (max - min + 1)) + min;
}

/**
 * Filters out invalid CSS class names and joins valid ones
 * @param {array} classNames An array of CSS class names
 * @returns {array}
 */
export function buildClassString(classNames) {
  return classNames
    .filter(className => /[a-zA-Z0-9_-]+/.test(className))
    .join(" ");
}
